import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_181: DocMigration = {
  maxSchemaVersion: "0.0.181",
  description: "Adds a builderRefs field to the Doc",
  apply(json: any) {
    if (!json.builderRefs) {
      json.builderRefs = {};
    }
    return json;
  },
};

export default migration_0_0_181;
